import store from '@/store'
import { refreshManualDonations } from '@/composables/useManualGivingDonations'

/**
 * Refetch the donor data that the free tier either couldn't access (donations
 * 403) or received truncated (most-recent statement only), so the newly-unlocked
 * paid data replaces the cached free view.
 *
 * Call the returned refreshDataAfterUpgrade() after a successful upgrade.
 * fetchDonorDonations refreshes the store, which every mounted
 * useDonorFinancialYears instance watches, so the donations page re-syncs.
 */
export async function refreshDataAfterUpgrade() {
  await Promise.all([
    refreshManualDonations(),
    store.dispatch('fetchDonorDonations'),
    store.dispatch('fetchUserStatements'),
    store.dispatch('fetchStatementYears'),
  ])
}
